/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Push_OnInputs */

const en_us2_profile_push_on = /** @type {(inputs: Profile_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On: alerts arrive here.`)
};

const pt_br2_profile_push_on = /** @type {(inputs: Profile_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligadas: os avisos chegam aqui.`)
};

const es_419_profile_push_on = /** @type {(inputs: Profile_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activadas: los avisos llegan aquí.`)
};

const pt_pt2_profile_push_on = /** @type {(inputs: Profile_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ligadas: os avisos chegam aqui.`)
};

const fr_fr2_profile_push_on = /** @type {(inputs: Profile_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activées : les alertes arrivent ici.`)
};

const de_de2_profile_push_on = /** @type {(inputs: Profile_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An: Hinweise kommen hier an.`)
};

const it_it2_profile_push_on = /** @type {(inputs: Profile_Push_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attive: gli avvisi arrivano qui.`)
};

/**
* | output |
* | --- |
* | "On: alerts arrive here." |
*
* @param {Profile_Push_OnInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_push_on = /** @type {((inputs?: Profile_Push_OnInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Push_OnInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_push_on(inputs)
	if (locale === "es-419") return es_419_profile_push_on(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_push_on(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_push_on(inputs)
	if (locale === "de-DE") return de_de2_profile_push_on(inputs)
	if (locale === "it-IT") return it_it2_profile_push_on(inputs)
	return en_us2_profile_push_on(inputs)
});
export { profile_push_on as "profile.push_on" }